import React from 'react'
import { CSVLink} from "react-csv";

const ExportCSV = (props) => {
  return (
    <CSVLink filename={props.fileName} data={props.data}>{props.name}</CSVLink>
  )
}

export default ExportCSV